var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoricSubject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3299 7.92003C20.9199 7.92003 20.5799 7.58003 20.5799 7.17003V5.35003C20.5799 4.62003 19.9899 4.03003 19.2599 4.03003H4.73992C4.00992 4.03003 3.41992 4.62003 3.41992 5.35003V7.18003C3.41992 7.59003 3.07992 7.93003 2.66992 7.93003C2.25992 7.93003 1.91992 7.59003 1.91992 7.17003V5.35003C1.91992 3.79003 3.18992 2.53003 4.73992 2.53003H19.2599C20.8199 2.53003 22.0799 3.80003 22.0799 5.35003V7.18003C22.0799 7.59003 21.7499 7.92003 21.3299 7.92003Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.4701C11.59 21.4701 11.25 21.1301 11.25 20.7201V4.11011C11.25 3.70011 11.59 3.36011 12 3.36011C12.41 3.36011 12.75 3.70011 12.75 4.11011V20.7201C12.75 21.1401 12.41 21.4701 12 21.4701Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9401 21.47H8.06006C7.65006 21.47 7.31006 21.13 7.31006 20.72C7.31006 20.31 7.65006 19.97 8.06006 19.97H15.9401C16.3501 19.97 16.6901 20.31 16.6901 20.72C16.6901 21.13 16.3501 21.47 15.9401 21.47Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoricSubject);
export default __webpack_public_path__ + "static/media/HistoricSubject.0aa85acf.svg";
export { ForwardRef as ReactComponent };